/**
 * Validates flow template name format:
 *
 * Required format: "FLOW_NAME ;; FLOW_DESCRIPTION ;; CATEGORIES"
 * Optional format: "FLOW_NAME ;; FLOW_DESCRIPTION ;; CATEGORIES ;; APP_TYPES"
 *
 * Pattern breakdown:
 * - ^(.+?) - Group 1: Flow name (one or more characters, non-greedy)
 * -  ;;  - Literal separator (space-semicolon-semicolon-space)
 * - (.+?) - Group 2: Flow description (one or more characters, non-greedy)
 * -  ;;  - Literal separator
 * - ([^,\s]+(?:,[^,\s]+)*) - Group 3: Categories (comma-separated, no spaces in individual items)
 *   - [^,\s]+ - One or more characters that are not comma or whitespace
 *   - (?:,[^,\s]+)* - Zero or more occurrences of comma followed by non-comma/non-space chars
 * - (?: ;; ([^,\s]+(?:,[^,\s]+)*))? - Optional Group 4: App types (same pattern as categories)
 *   - (?:...) - Non-capturing group for the optional section
 *   - ? - Makes the entire app types section optional
 * - $ - End of string
 *
 * Examples:
 * - Valid: "My Flow ;; Description ;; Cat1,Cat2,Cat3"
 * - Valid: "My Flow ;; Description ;; Cat1,Cat2 ;; APP1,APP2"
 * - Invalid: "My Flow ;; Description" (missing categories)
 * - Invalid: "My Flow ;; Description ;; Cat1, Cat2" (spaces in categories)
 */
const FLOW_TEMPLATE_REGEX =
  /^(.+?) ;; (.+?) ;; ([^,\s]+(?:,[^,\s]+)*)(?: ;; ([^,\s]+(?:,[^,\s]+)*))?$/;

const isValidTemplateName = (name: string) => FLOW_TEMPLATE_REGEX.test(name);

export default isValidTemplateName;
